module.exports = __webpack_public_path__ + "static/media/15.1.79c2dbfc.png";